import React from 'react';
import MeetingPanelEmptyState from './MeetingPanelEmptyState';
import MeetingPanelTactical from './MeetingPanelTactical';
import MeetingPanelPilotage from './MeetingPanelPilotage';
import GovernancePanel from './GovernancePanel';

// Réunion de cercle : gouvernance, tactique ou pilotage selon le type.

const MeetingPanel = ({
  selectedCircle,
  activeMeeting,
  meetingError,
  onDismissError,
  meetingParticipants,
  meetingDraft,
  meetingTensions,
  selectedMeetingTensionId,
  meetingNotes,
  presenceCount,
  connectedUsers = [],
  realtimeConnected,
  meetingFormVisible = false,
  meetingPoints = [],
  meetingPreparedPoints = [],
  meetingPreparedPointsLoading = false,
  selectedMeetingPointId,
  selectedMeetingProjectId,
  meetingProjectReviews = [],
  meetingPointComposer,
  tensions,
  circles,
  employees = [],
  projects = [],
  projectSprints = {},
  onFetchProjectSprints,
  onFetchProjectObjectives,
  meetingPhase,
  onSelectMeetingPhase,
  user,
  meetingLoading,
  selectedCircleIsRole = false,
  onCloseMeeting,
  onImportTension,
  onTransferSecretary,
  onInviteParticipant,
  onMeetingDraftChange,
  onCreateMeetingTension,
  onRefreshMeetingTensions,
  onSelectMeetingTension,
  onLiveEditTension,
  onMeetingDecision,
  onStructureChanged,
  onAddMeetingPoint,
  onImportMeetingPoint,
  onSelectMeetingPoint,
  onPointDecision,
  onPointToTension,
  onPointNotesChange,
  onPointComposerUpdate,
  onCreatePointTask,
  onCreatePointObjective,
  onSelectMeetingProject,
  onFetchProjectReviews,
  onUpdateProjectReview,
  meetingLive,
  liveActions,
  meetingFocus,
  meetingFocusList,
  focusActions,
  apiUrl,
  onNotesChange,
  onToggleForm,
  metricsRange,
  metricsRangeValid,
}) => {
  const effectiveUserId = user?.employee_id ?? user?.id;
  const userIsSecretary = String(activeMeeting?.created_by) === String(effectiveUserId);
  const meetingType = (activeMeeting?.type || 'gouvernance').toLowerCase();
  const isTactical = meetingType === 'tactique';
  const isPilotage = meetingType === 'pilotage';

  // If no meeting open
  if (!activeMeeting) {
    return <MeetingPanelEmptyState selectedCircleIsRole={selectedCircleIsRole} />;
  }


  if (isTactical) {
    return (
      <MeetingPanelTactical
        activeMeeting={activeMeeting}
        selectedCircle={selectedCircle}
        meetingError={meetingError}
        meetingParticipants={meetingParticipants}
        meetingPoints={meetingPoints}
        preparedPoints={meetingPreparedPoints}
        preparedPointsLoading={meetingPreparedPointsLoading}
        selectedMeetingPointId={selectedMeetingPointId}
        selectedMeetingProjectId={selectedMeetingProjectId}
        meetingProjectReviews={meetingProjectReviews}
        meetingPointComposer={meetingPointComposer}
        connectedUsers={connectedUsers}
        realtimeConnected={realtimeConnected}
        presenceCount={presenceCount}
        employees={employees}
        projects={projects}
        projectSprints={projectSprints}
        onFetchProjectSprints={onFetchProjectSprints}
        onFetchProjectObjectives={onFetchProjectObjectives}
        meetingPhase={meetingPhase}
        onSelectMeetingPhase={onSelectMeetingPhase}
        circles={circles}
        userIsSecretary={userIsSecretary}
        onCloseMeeting={onCloseMeeting}
        onTransferSecretary={onTransferSecretary}
        onInviteParticipant={onInviteParticipant}
        onAddMeetingPoint={onAddMeetingPoint}
        onImportMeetingPoint={onImportMeetingPoint}
        onSelectMeetingPoint={onSelectMeetingPoint}
        onPointDecision={onPointDecision}
        onPointNotesChange={onPointNotesChange}
        onPointComposerUpdate={onPointComposerUpdate}
        onCreatePointTask={onCreatePointTask}
        onCreatePointObjective={onCreatePointObjective}
        onSelectMeetingProject={onSelectMeetingProject}
        onFetchProjectReviews={onFetchProjectReviews}
        onUpdateProjectReview={onUpdateProjectReview}
        meetingLive={meetingLive}
        liveActions={liveActions}
        meetingFocus={meetingFocus}
        meetingFocusList={meetingFocusList}
        focusActions={focusActions}
        apiUrl={apiUrl}
        metricsRange={metricsRange}
        metricsRangeValid={metricsRangeValid}
      />
    );
  }

  if (isPilotage) {
    return (
      <MeetingPanelPilotage
        activeMeeting={activeMeeting}
        selectedCircle={selectedCircle}
        meetingError={meetingError}
        meetingParticipants={meetingParticipants}
        selectedMeetingProjectId={selectedMeetingProjectId}
        meetingProjectReviews={meetingProjectReviews}
        connectedUsers={connectedUsers}
        realtimeConnected={realtimeConnected}
        presenceCount={presenceCount}
        employees={employees}
        projects={projects}
        circles={circles}
        projectSprints={projectSprints}
        onFetchProjectSprints={onFetchProjectSprints}
        onFetchProjectReviews={onFetchProjectReviews}
        onUpdateProjectReview={onUpdateProjectReview}
        userIsSecretary={userIsSecretary}
        onCloseMeeting={onCloseMeeting}
        onTransferSecretary={onTransferSecretary}
        onInviteParticipant={onInviteParticipant}
        onSelectMeetingProject={onSelectMeetingProject}
      />
    );
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-md h-auto overflow-visible">
      <GovernancePanel
        selectedCircle={selectedCircle}
        activeMeeting={activeMeeting}
        meetingError={meetingError}
        onDismissError={onDismissError}
        meetingParticipants={meetingParticipants}
        meetingDraft={meetingDraft}
        meetingTensions={meetingTensions}
        selectedMeetingTensionId={selectedMeetingTensionId}
        meetingNotes={meetingNotes}
        presenceCount={presenceCount}
        connectedUsers={connectedUsers}
        realtimeConnected={realtimeConnected}
        meetingFormVisible={meetingFormVisible}
        meetingPoints={meetingPoints}
        selectedMeetingPointId={selectedMeetingPointId}
        tensions={tensions}
        circles={circles}
        employees={employees}
        user={user}
        meetingLoading={meetingLoading}
        onCloseMeeting={onCloseMeeting}
        onImportTension={onImportTension}
        onTransferSecretary={onTransferSecretary}
        onInviteParticipant={onInviteParticipant}
        onMeetingDraftChange={onMeetingDraftChange}
        onCreateMeetingTension={onCreateMeetingTension}
        onRefreshMeetingTensions={onRefreshMeetingTensions}
        onSelectMeetingTension={onSelectMeetingTension}
        onLiveEditTension={onLiveEditTension}
        onMeetingDecision={onMeetingDecision}
        onStructureChanged={onStructureChanged}
        onAddMeetingPoint={onAddMeetingPoint}
        onSelectMeetingPoint={onSelectMeetingPoint}
        onPointDecision={onPointDecision}
        onPointToTension={onPointToTension}
        onNotesChange={onNotesChange}
        onToggleForm={onToggleForm}
      />
    </div>
  );
};

export default MeetingPanel;
